import React from "react";
import {
  GiSpeedBoat,
  GiSailboat,
  GiWaveSurfer,
  GiCompass,
} from "react-icons/gi";
import { MdExplore } from "react-icons/md";
import { NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "Home", icon: <MdExplore size={24} /> },
  {
    to: "/boat-tours",
    label: "Boat Tours",
    icon: <GiSpeedBoat size={24} />,
  },
  {
    to: "/unique-tours",
    label: "Unique Tours",
    icon: <GiCompass size={24} />,
  },
  {
    to: "/luxury-yacht",
    label: "Luxury Yacht",
    icon: <GiSailboat size={24} />,
  },
  {
    to: "/jet-ski",
    label: "Jet Ski's",
    icon: <GiWaveSurfer size={24} />,
  },
];

const NavFilters = () => {
  const homeItem = navItems[0];
  const otherItems = navItems.slice(1);

  return (
    <div className="relative w-full px-3 py-3 lg:px-6 lg:py-5 bg-white/80 dark:bg-gray-900/80 backdrop-blur-lg shadow-xl dark:shadow-cyan-500/10 rounded-2xl lg:rounded-3xl max-w-[95%] sm:max-w-[90%] lg:max-w-5xl mx-auto mt-4 mb-4 md:mb-6 border border-cyan-100/50 dark:border-cyan-900/50 overflow-hidden">
      {/* Wave decoration */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 animate-wave"></div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 animate-wave-reverse"></div>

      <div className="flex flex-col gap-2.5 lg:gap-4 relative z-10">
        {/* Home link - full width on mobile, centered */}
        <div className="lg:hidden">
          <NavLink
            to={homeItem.to}
            end
            className={({ isActive }) =>
              `flex flex-col items-center justify-center text-center gap-y-1 p-3 rounded-xl transition-all duration-300 ease-in-out transform group ${
                isActive
                  ? "bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-lg shadow-cyan-500/50"
                  : "bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 text-blue-600 dark:text-cyan-400 hover:from-blue-500 hover:to-cyan-500 hover:text-white dark:hover:from-blue-600 dark:hover:to-cyan-600 hover:shadow-lg hover:shadow-cyan-400/30"
              } hover:scale-105 hover:-translate-y-1`
            }
          >
            <div className="transform transition-transform group-hover:scale-110 group-hover:rotate-12">
              {homeItem.icon}
            </div>
            <span className="text-xs font-medium">{homeItem.label}</span>
          </NavLink>
        </div>

        {/* Other items - 2 columns on mobile */}
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-2.5 lg:gap-4">
          {/* Desktop: Show home with others */}
          <NavLink
            to={homeItem.to}
            end
            className={({ isActive }) =>
              `hidden lg:flex flex-col items-center justify-center text-center gap-y-2 p-5 h-[100px] rounded-xl transition-all duration-300 ease-in-out transform group ${
                isActive
                  ? "bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-lg shadow-cyan-500/50"
                  : "bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 text-blue-600 dark:text-cyan-400 hover:from-blue-500 hover:to-cyan-500 hover:text-white dark:hover:from-blue-600 dark:hover:to-cyan-600 hover:shadow-lg hover:shadow-cyan-400/30"
              } hover:scale-105 hover:-translate-y-1`
            }
          >
            <div className="transform transition-transform group-hover:scale-110 group-hover:rotate-12">
              {homeItem.icon}
            </div>
            <span className="text-sm font-medium">{homeItem.label}</span>
          </NavLink>

          {otherItems.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center text-center gap-y-1 lg:gap-y-2 p-3 lg:p-5 h-[70px] lg:h-[100px] rounded-xl transition-all duration-300 ease-in-out transform group ${
                  isActive
                    ? "bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-lg shadow-cyan-500/50"
                    : "bg-gradient-to-br from-slate-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 text-blue-600 dark:text-cyan-400 hover:from-blue-500 hover:to-cyan-500 hover:text-white dark:hover:from-blue-600 dark:hover:to-cyan-600 hover:shadow-lg hover:shadow-cyan-400/30"
                } hover:scale-105 hover:-translate-y-1 overflow-visible`
              }
            >
              <div className="transform transition-transform group-hover:scale-110 group-hover:rotate-12">
                {icon}
              </div>
              <span className="text-xs lg:text-sm font-medium">{label}</span>
              {to === "/boat-tours" && (
                <span className="absolute -top-2 -right-2 bg-gradient-to-r from-orange-500 to-pink-500 text-white text-[10px] px-2 py-0.5 rounded-full font-bold shadow-lg animate-pulse">
                  HOT
                </span>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NavFilters;
